import React from 'react';
const rows = [['Evenings building next week’s class', 'Two pages and ten minutes of music'], ['Hunting for the right track at midnight', 'A music brief for every phase'], ['Energy that peaks too soon or never lands', 'Rise, Deepen, Return — every time'], ['Newcomers who come once and disappear', 'A whole volume of first classes'], ['A retreat built from a blank page', 'Programs timed from Friday to Sunday']];
export function CostOfInaction() {
  return <section className="w-full bg-pine" data-id="element-69" data-mp="38xlnzwiya9ai">
      <div className="mx-auto max-w-3xl px-5 py-14 sm:py-20" data-id="element-70" data-mp="38wk1mvwhi0dh">
        <h2 className="text-center font-display text-[28px] leading-tight text-paper sm:text-4xl" data-id="element-71" data-mp="3doljqygc2lbf">
          What another year of building every class from scratch costs you
        </h2>
        <div className="mt-8 overflow-hidden rounded-2xl border border-paper/15" data-id="element-72" data-mp="3ip9bxngat878">
          <div className="grid grid-cols-2 text-center" data-id="element-73" data-mp="3nketka2o40pi">
            <div className="border-r border-paper/15 bg-signal px-3 py-3 font-display text-base text-white sm:text-lg" data-id="element-74" data-mp="3smnovd30jeus">
              From scratch
            </div>
            <div className="bg-forest px-3 py-3 font-display text-base text-white sm:text-lg" data-id="element-75" data-mp="39hd5gp3gvomn">
              Vivencia Ready
            </div>
          </div>
          {rows.map(([bad, good]) => <div key={bad} className="grid grid-cols-2 border-t border-paper/15 text-[13px] leading-snug sm:text-sm" data-id="element-76" data-mp="30gortvhzjqaa">
              <div className="border-r border-paper/15 px-3.5 py-3.5 text-paper/60 line-through decoration-signal/60" data-id="element-77" data-mp="111wloplgj2y">
                {bad}
              </div>
              <div className="px-3.5 py-3.5 font-semibold text-paper" data-id="element-78" data-mp="3ngmn7t7bmqsq">{good}</div>
            </div>)}
        </div>
      </div>
    </section>;
}